import { Box, useTheme , Link} from "@mui/material";
import Header from "../../components/global/Header";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { tokens } from "../../theme";
import {Link as RouterLink } from "react-router-dom";

const FAQ = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);


  return (
    <Box m="20px">
      <Header title="FAQ" subtitle="Get going quickly with Jazzy Sign" />

      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography color={colors.greenAccent[500]} variant="h5">
            What is Jazzy Sign?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            A really cool app that lets you create and manage signs all over the world
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography color={colors.greenAccent[500]} variant="h5">
            What do I need to use Jazzy Sign?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            First off you need a Sign, if you dont have one you can get one <Link component={RouterLink} color={colors.greenAccent[400]}  to="../store">here...</Link>
          </Typography>
          <Typography>
            Then you will need an account here on JazzySign.com, if you dont have one get one <Link component={RouterLink} color={colors.greenAccent[400]}  to="../register">here...</Link>.
          </Typography>
          <Typography>
            Now you can create images, custom messages and view details about your sign's ocation, such as temperature and light levels.
          </Typography>

          <Typography ><br></br></Typography>

          <Typography variant="h4">
            The most important thing is a little imagination, and just have fun....
          </Typography>


        </AccordionDetails>
      </Accordion>


      
    </Box>
  );
};

export default FAQ;
